import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { videoLegacyDefaultV0Schema } from './default';
import { videoLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field. Persisted entities
 * without a `type` field land on the default branch (its `type` literal is
 * `.optional()`); entities tagged `type: 'zero'` land on the zero branch.
 *
 * The data shape under `data` is identical between the two branches today —
 * the divergence is only the envelope discriminator. If/when the variants
 * grow per-variant data fields, this union is where the new shapes plug in.
 */
const videoLegacyEntityUnion = z.discriminatedUnion('type', [videoLegacyDefaultV0Schema, videoLegacyZeroV0Schema]);

export type LegacyVideoDefault = z.infer<typeof videoLegacyDefaultV0Schema>;
export type LegacyVideoZero = z.infer<typeof videoLegacyZeroV0Schema>;
export type LegacyVideo = LegacyVideoDefault | LegacyVideoZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single 'web' variant today; the mini-landing shape becomes a second variant when
 * the widget is unified across apps. When a redesigned `default/v0` lands, this
 * switches to a versioned schema and the variants gain `up` migrations into it.
 */
export const LegacyVideoEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: videoLegacyEntityUnion }]);
